import { Component, OnInit } from "@angular/core";
import { NavController, ToastController } from "ionic-angular";
import SortOptions from "models/content-wrapper/sort-options";
import { ClearinghouseDetail } from "models/payers/payer";
import { PayersService } from "providers/payers-service/payers.service";
import { Subscription } from "rxjs";
import { ConfigureClearinghousePage } from "./configure-clearinghouse/configure-clearinghouse";

@Component({
  selector: "clearinghouse-view",
  templateUrl: "clearinghouse-view.html",
})
export class ClearingHouseView implements OnInit {
  // The panel copy for "this tenant has no profiles" and for "we could not read them".
  // They are different situations: showing the first one after a 500 tells an operator
  // their clearinghouse config is gone when it is only unreadable.
  static readonly NO_PROFILES_MESSAGE = "No Clearinghouse has been entered";
  static readonly LOAD_FAILED_MESSAGE =
    "Unable to load clearinghouse profiles. Please try again.";

  clearingHouseData: ClearinghouseDetail[] = [];
  currentPage: number = 0;
  pages: number[] = [];
  totalPages: number = 0;
  totalElements: number = 0;
  sortedBy = "clearingHouse,desc";
  subscriptions: Subscription[] = [];
  private listSubscription: Subscription;
  sortOptions: SortOptions = new SortOptions("clearingHouse", "asc");
  pageSize: number = 10;

  changesPageSize: number = 10;
  facilityTypeItems: any[];
  statusItems: any[];
  responseMsg: string = ClearingHouseView.NO_PROFILES_MESSAGE;
  totalPatients: number = 0;
  loading: boolean = false;

  constructor(
    private toastCtrl: ToastController,
    protected navCtrl: NavController,
    private payersService: PayersService
  ) {}

  ngOnInit() {
    this.loadClearinghouses();
  }

  // Load the tenant's clearinghouse profiles from the live list endpoint
  // (GET /claim-submission/clearinghouse). Also called by the create form's parent
  // callback after a successful save so a newly-created profile appears immediately.
  loadClearinghouses() {
    this.loading = true;
    this.responseMsg = ClearingHouseView.NO_PROFILES_MESSAGE;
    // Re-entrant — the create form calls this back after every save. Replace the previous
    // subscription instead of stacking one per reload for the life of the screen.
    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }
    this.listSubscription = this.payersService.getClearinghouseOptions().subscribe(
      (data) => {
        this.clearingHouseData = data || [];
        this.loading = false;
      },
      (error) => {
        this.clearingHouseData = [];
        this.loading = false;
        this.responseMsg = ClearingHouseView.LOAD_FAILED_MESSAGE;
        this.displayErrorResponse(error);
      }
    );
  }

  displayErrorResponse(error) {
    let message = "Unable to load clearinghouse profiles";
    if (error && error.error && error.error.displayObject) {
      message = error.error.displayObject.error;
    }
    let toast = this.toastCtrl.create({
      message,
      duration: 4000,
      position: "below",
      cssClass: "error",
    });
    toast.present();
  }

  newClearingHouse() {
    this.navCtrl.push(ConfigureClearinghousePage, {
      parent: this,
      // The profile name is how a profile is identified everywhere downstream (the
      // Payer/EDI picker shows nothing else), and neither the form nor the backend
      // checked it — so a tenant could end up with two "Waystar-Medicare" profiles,
      // indistinguishable and undeletable. The grid already knows the taken names.
      existingProfileNames: this.clearingHouseData.map(
        (c) => c.clearinghouseProfileName
      ),
    });
  }

  ngOnDestroy(): void {
    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }
    this.subscriptions.forEach((val) => val.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/clearinghouse-view/clearinghouse-view.ts